








































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as FORM_INTERFACE from '../interfaces/accessTicket.interface';
import * as rules from '@/modules/shared/shared/domain/rules';

@Component({
    components: {},
})
// TODO: change the name of the item
export default class ItemHardware extends Vue {
    @Prop()
    isFormComplete!: number;
    @Prop()
    oldHardwareTransfer!: FORM_INTERFACE.hardwareTransferInterface;

    @Prop({ default: {} })
    formValues!: {
        accessEquipmentDepartureTypes: {
            value: number;
            text: string;
        }[];
        accessEquipmentDeparturePeriodTypes: {
            value: number;
            text: string;
        }[];
        movementTypes: {
            value: number;
            text: string;
        }[];
    };

    isFormValid: boolean = true;
    transferInformation: FORM_INTERFACE.transferInformationInterface = {
        movementType: {
            id: 0,
            name: '',
        },
        reasonForTransfer: {
            id: undefined,
            name: undefined,
        },
        lengthOfTransfer: undefined,
        destination: undefined,
        motive: undefined,
    };
    hardware: FORM_INTERFACE.hardwareInterface = {
        name: '',
        model: '',
        brand: '',
        measureUnit: '',
        nominalVoltage: '',
        serialNumber: '',
        nominalConsumption: '',
    };
    rules: any = rules;

    @Watch('isFormComplete')
    sendData(value: boolean, oldValue: boolean) {
        this.formValues.movementTypes.forEach(type => {
            if (this.transferInformation.movementType.id == type.value) {
                this.transferInformation.movementType.name = type.text;
            }
        });
        let hardwareTransfer: FORM_INTERFACE.hardwareTransferInterface = {
            transferInformation: this.transferInformation,
            hardware: this.hardware,
        };
        this.$emit('receiveData', hardwareTransfer);
    }

    get isEntry() {
        this.resetForm();
        return this.transferInformation.movementType.id == 1;
    }

    get isExit() {
        this.resetForm();
        return this.transferInformation.movementType.id == 2;
    }

    resetForm() {
        this.transferInformation.reasonForTransfer = {
            id: undefined,
            name: undefined,
        };
        (this.transferInformation.lengthOfTransfer = undefined),
            (this.transferInformation.destination = undefined),
            (this.transferInformation.motive = undefined);
        this.hardware.name = '';
        this.hardware.model = '';
        this.hardware.brand = '';
        this.hardware.measureUnit = '';
        this.hardware.nominalVoltage = '';
        this.hardware.serialNumber = '';
        this.hardware.nominalConsumption = '';
    }
}
